export default __webpack_public_path__ + "static/media/Tools-P4-CIFOR.ab5a7b69.jpg";